import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, Show, TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import './Component_HomeDDXV2.scss';
import { AdvisorConfigKeyFE_HomePanel, ModuleFE_AdvisorState, ModuleFE_EMInterface } from '@app/advisor-frontend';
import { ConsiderationGroupEnum } from '@app/advisor-shared';
import { exists } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { dispatch_OnAddProtocol } from '../../../../panels/AdvisorPanel_AddProtocolData/renderers/Renderer_AddProtocol/dispatchers.js';
import { ModuleFE_AdvisorAnalytics } from '../../../../../_analytics/consts.js';
import { Component_Protocols } from './Component_Protocols/Component_Protocols.js';
const fallback_Title = 'Key Differentials & Workup';
const fallback_Subtitle = 'Asses and determine next steps for protocols';
export class Component_HomeDDXV2 extends ComponentSync {
    __onPractitionerConfigUpdated = () => {
        this.setState({ collapsed: ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.ddx() ?? true });
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.collapsed ??= ModuleFE_AdvisorState.getStateProperty.collapsing.homePanel.ddx() ?? true;
        state.config ??= AdvisorConfigKeyFE_HomePanel.get().sections?.ddx;
        return state;
    }
    //######################### Logic #########################
    openAddProtocol = (e) => {
        e.stopPropagation();
        if (ModuleFE_EMInterface.isReadonly())
            return;
        dispatch_OnAddProtocol.dispatchUI(ConsiderationGroupEnum.HIGH_CONSIDERATION);
    };
    onClose = () => {
        if (this.state.collapsed)
            return;
        ModuleFE_AdvisorState.setProperty.collapsing.homePanel.ddx(true);
    };
    onOpen = () => {
        if (!this.state.collapsed)
            return;
        ModuleFE_AdvisorState.setProperty.collapsing.homePanel.ddx(false);
        ModuleFE_AdvisorAnalytics.trigger.view.view__keyDDX({ method: 'manual' });
    };
    //######################### Render #########################
    render() {
        return _jsx(TS_CollapsableContainerV2, { className: 'home-ddx-v2', onCollapseToggle: this.onClose, collapsed: this.state.collapsed, headerRenderer: this.render_Header, containerRenderer: this.render_Body, forceUpdate: true, animated: true });
    }
    //######################### Render - Header #########################
    render_Header = () => {
        const title = this.state.config?.title ?? fallback_Title;
        const subtitle = this.state.config?.subtitle ?? fallback_Subtitle;
        return _jsxs(_Fragment, { children: [_jsxs(LL_V_L, { children: [_jsx(LL_H_C, { className: 'home-ddx__title-wrapper', children: _jsx("div", { className: 'home-ddx__title', children: title }) }), exists(subtitle) && _jsx("div", { className: 'home-ddx__subtitle', children: subtitle })] }), this.render_Header_Tail()] });
    };
    render_Header_Tail = () => {
        return _jsx(LL_H_C, { className: 'home-ddx__header-tail', children: _jsxs(Show, { children: [_jsx(Show.If, { condition: !this.state.collapsed && !ModuleFE_EMInterface.isReadonly(), children: _jsx(ICONS.advisor_avn_add.component, { onClick: this.openAddProtocol }) }), _jsx(Show.If, { condition: this.state.collapsed, children: _jsx(Button, { variant: 'primary', onClick: this.onOpen, children: "View" }) })] }) });
    };
    //######################### Render - Body #########################
    render_Body = () => {
        return _jsx(Component_Protocols, {});
    };
}
//# sourceMappingURL=Component_HomeDDXV2.js.map